// Path: ./src/app/components/DatePickerMui/styled.ts
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 400px;
`;

interface TextProps {
  textCss?: string;
}
export const Text = styled.div<TextProps>`
  font-size: 23px;
  margin-right: 10px;
  ${(props) => {
    return props?.textCss ? props?.textCss : "";
  }}
`;
